import React from 'react'

import CloseIcon from '../../assets/img/ico-close.svg?react'

import UserPart from './UserPart'
export interface UserPartListProps {
    id: number
    src: string
    name: string
    email?: string
    role: string
}
interface SelectedUsersListProps {
    list: UserPartListProps[]
    removeAction: (value: number) => void
}
const SelectedUsersList = ({ list, removeAction }: SelectedUsersListProps) => {
    return (
        <ul className="search-results-list">
            {list.length > 0 ? (
                list.map((el, index) => (
                    <li className="search-results--item" key={index}>
                        <div className="search--row">
                            <div className="search--row--item overflow-x-hidden">
                                <UserPart
                                    src={el.src}
                                    name={el.name}
                                    email={el.email}
                                />
                            </div>
                            <div className="search--row--item">
                                <p className="status-chat-select">{el.role}</p>
                                <button
                                    onClick={() => removeAction(el.id)}
                                    className="btn btn-remove"
                                >
                                    <span className="ico">
                                        <CloseIcon />
                                    </span>
                                </button>
                            </div>
                        </div>
                    </li>
                ))
            ) : (
                <li className="text-center">No users selected</li>
            )}
        </ul>
    )
}

export default SelectedUsersList
